export const I18N_PARTIAL_ACTIONS_EN = {
  ACTION: {
    SINGULAR: 'Action',
    PLURAL: 'Actions',
    ADD: { GENERIC: 'Add' },
    RELOAD: { GENERIC: 'Reload' },
    SEARCH: { GENERIC: 'Search' },
    SAVE: { GENERIC: 'Save', AND_CONTINUE: 'Save and continue' },
    EDIT: { GENERIC: 'Edit' },
    DISCARD: { GENERIC: 'Reset' },
    CANCEL: { GENERIC: 'Cancel' },
    SEND: { GENERIC: 'Send', EMAIL: 'Send email' },
    CLOSE: { GENERIC: 'Exit' },
    AGREE: { GENERIC: 'Accept', IAGREE: 'I agree' },
    CONFIRM: {
      GENERIC: "I've got it!",
      YES: 'Yes, sure',
      DELETED: 'Yes, delete!',
      ACCOUNT: 'Confirm account',
    },
    DETAIL: { GENERIC: 'Detail', VIEW: 'View details' },
    APPLY: { GENERIC: 'Apply' },
    ACCESS: { GENERIC: 'Access' },
    UPDATE: { GENERIC: 'Update' },
    REGISTER: { GENERIC: 'Register' },
    CONTINUE: { GENERIC: 'Continue' },
    FINALIZE: { GENERIC: 'Finalize' },
    GO_BACK: { GENERIC: 'Go back', LIST: 'Return to list' },
    NEW: { GENERIC: 'New' },
    EVALUATE: { GENERIC: 'Evaluate' },
    GO: { GENERIC: 'Go' },
    REMOVE: { GENERIC: 'Remove', CLEAN: 'Clean' },
    UPLOAD: { GENERIC: 'Upload' },
    FILTER: { GENERIC: 'Filter' },
    SELECT: { GENERIC: 'Select', DATE: 'Select date' },
    IMPORT: { GENERIC: 'Import', DATA: 'Import data' },
    SING_IN: { GENERIC: 'Sign in' },
    TODAY: 'Today',
  },
};

export const I18_PARTIAL_VALIDATIONS_RULES_EN = {
  VALIDATION: {
    REQUIRED: 'Required field.',
    MIN_LENGTH:
      'This value is too short. It should have at least {{ min }} characters.',
    MAX_LENGTH:
      'This value is too long. It should have {{ max }} characters or less.',
    MIN: 'Enter a value greater than or equal to {{ min }}.',
    MAX: 'Enter a value less than or equal to {{ max }}.',
    RANGE: 'Enter a value between {{ min }} and {{ max }}.',
    DATE: 'This value is not a valid date.',
    DATETIME: 'This value is not a valid date and time.',
    EMAIL: 'This value is not a valid email address.',
    URL: 'This value is not a valid URL.',
    PASSWORD_MATCH: 'Passwords do not match.',
    PASSWORD_STRENGTH:
      'The password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and be no fewer than {{ length }} characters long.',
  },
};

export const I18_PARTIAL_ALERTS_EN = {
  ALERT: {
    SUCCESS: 'Operation completed successfully',
    CONFIRM_TITLE: 'Are you sure?',
    CONFIRM_TEXT: 'You will not be able to undo this action!',
    CONFIRM_BUTTON_TEXT: 'Yes, sure',
    DEFAULT_CONFIRM_BUTTON_TEXT: "I've got it!",
    DEFAULT_CANCEL_BUTTON_TEXT: 'Cancel',
    ERROR_TITLE: 'An error occurred',
    ERROR: 'Sorry, it seems some errors were detected. Please try again.',
  },
  ERROR: {
    FORBIDDEN: 'You do not have permission to perform this action.',
    EMAIL_ALREADY_REGISTERED: 'That email address is already registered.',
    EMAIL_ALREADY_IN_USE: 'That email address is already in use.',
    TOO_MANY_REQUESTS: 'Too many requests. Please wait a moment and try again.',
  },
};

export const I18N_PARTIAL_TIME_PERIODICITY_EN = {
  PERIODICITY: {
    NONE: 'None',
    TODAY: 'Today',
    IN: 'In',
    AGO: 'Ago',
    SINCE: 'Since',
    EVERY_WEEK: 'Weekly',
    EVERY_DAY: 'Daily',
    EVERY_CERTAIN_DAYS: 'Every {{value}} days',
    EVERY_CERTAIN_WEEKS: 'Every {{value}} weeks',
    EVERY_MONTH: 'Monthly',
    EVERY_QUARTER: 'Quarterly',
    EVERY_SEMESTER: 'Biannually',
    EVERY_CERTAIN_MONTHS: 'Every {{value}} months',
    EVERY_YEAR: 'Yearly',
    EVERY_CERTAIN_YEARS: 'Every {{value}} years',
    YEARS: 'Years',
    YEAR: 'Year',
    MONTHS: 'Months',
    MONTH: 'Month',
    DAYS: 'Days',
    DAY: 'Day',
    WEEKS: 'Weeks',
    WEEK: 'Week',
    HOURS: 'Hours',
    HOUR: 'Hour',
    MINUTES: 'Minutes',
    MINUTE: 'Minute',
    SECONDS: 'Seconds',
    SECOND: 'Second',
  },
};

export const I18N_PARTIALS_EN = {
  ...I18N_PARTIAL_ACTIONS_EN,
  ...I18_PARTIAL_VALIDATIONS_RULES_EN,
  ...I18N_PARTIAL_TIME_PERIODICITY_EN,
  ...I18_PARTIAL_ALERTS_EN,
};
